<template>
  <TresMesh
    :material="material"
    :position="[0, 0, 0]"
    :rotation="[MathUtils.degToRad(-90), 0, 0]"
  >
    <TresPlaneGeometry :args="[0.06, 0.06]" />
    <!-- <TresMeshBasicMaterial color="red" /> -->
  </TresMesh>
</template>

<script setup lang="ts">
import { MathUtils } from "three"
import dotsParams from "@/components/three/shaders/dotsParams.glsl?raw"
import * as helpers from "@/components/three/shaders/helpers.js"
import * as config from "@/components/three/config/dots-map"
import baseVertex from "@/components/three/shaders/base.vert?raw"

const props = defineProps({
  show: {
    default: false,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const dotsUniforms = await useDotsUniforms()

const uniforms = {
  uThickness: {
    value: 0.02,
  },
  uProgress: {
    value: 0,
  },
  uOpacity: {
    value: 0,
  },
  ...dotsUniforms,
}

let tl
const radiate = () => {
  tl = $gsap.timeline({ repeat: -1 })
  tl.add("start")
  tl.fromTo(
    uniforms.uProgress,
    { value: 0 },
    { value: 1, duration: 1.0, ease: "power1.inOut" },
    "start"
  )
  tl.fromTo(
    uniforms.uOpacity,
    { value: 1 },
    { value: 0, duration: 1.0, ease: "power1.inOut" },
    "start"
  )
}

watch(
  () => props.show,
  () => {
    if (props.show) {
      radiate()
    } else {
      if (tl) {
        tl.repeat(0)
      }
    }
  }
)

const fragmentShader = /*glsl*/ `

  uniform float uThickness;
  uniform float uProgress;
  uniform float uOpacity;

  ${dotsParams}

  float circleShape (float radius, vec2 position) {
    float value = distance(position, vec2(0.5));
    return step(radius, value);
  }

  void main() {


    float innerRadius = (uProgress * 0.5) - uThickness;
    float innerCircle = circleShape(innerRadius, vUv);
    if (innerCircle == 0.0) {
      discard;
    }

    float outerRadius = (uProgress * 0.5);
    float outerCircle = circleShape(outerRadius, vUv);
    if (outerCircle == 1.0) {
      discard;
    }

    vec4 gradient = texture2D(tGradient, vUv);
    vec3 color = gradient.rgb;

    gl_FragColor = vec4(color * 3.0, uOpacity);
  }
`

const material = new ShaderMaterial({
  uniforms,
  vertexShader: baseVertex,
  fragmentShader,
  transparent: true,
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
